import { api } from '@triumph/shared';

const getContent = (dataSourceId) => api.get(`/api/partsfinder/content/${dataSourceId}`);

export default getContent;
